import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/application/src/components/accept-existing-user-invite.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/application/src/components/dashboard/global-view-manager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/application/src/components/dialogs/invite-user-dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/application/src/components/left-sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileShell"] */ "/opt/build/repo/application/src/components/mobile/mobile-shell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductOnboardingNudge"] */ "/opt/build/repo/application/src/components/product/product-onboarding-nudge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RouteOrgValidator"] */ "/opt/build/repo/application/src/components/route-org-validator.tsx");
